import { useCallback, useState } from "react";
import KSeFInvoiceRegister from "components/Registry/KSeFInvoiceRegister";
import FinancialOperationsRegister from "components/Registry/FinancialOperationsRegister";
import PostingOrdersRegister from "components/Registry/PostingOrdersRegister";
import { DEFAULT_DOC_TYPE, docGroupOf } from "components/Registry/DocTypeSelect/docTypes";
import { FC, Props } from "./typings";

/**
 * Połączona lista „Dokumenty księgowe" — jedna lokalizacja dla faktur/rachunków,
 * transakcji bankowych i poleceń księgowania. Selektor „Typ dokumentu" (w toolbarze
 * każdej podlisty) steruje tym, którą listę prezentujemy.
 */

const DOC_TYPE_KEY = "dokumentyKsiegowe_docType";

const DokumentyKsiegoweRegister: FC<Props> = ({ searchText, setSubtitle, initialDocType }) => {
  const [docType, setDocType] = useState<string>(
    () => initialDocType || localStorage.getItem(DOC_TYPE_KEY) || DEFAULT_DOC_TYPE,
  );

  const onDocTypeChange = useCallback((v: string) => {
    setDocType(v);
    try { localStorage.setItem(DOC_TYPE_KEY, v); } catch { /* ignore */ }
  }, []);

  const common = { searchText, setSubtitle, docType, onDocTypeChange };
  const group = docGroupOf(docType);

  if (group === "bank") return <FinancialOperationsRegister {...common} />;
  if (group === "jrn") return <PostingOrdersRegister {...common} />;
  return <KSeFInvoiceRegister {...common} />;
};

export default DokumentyKsiegoweRegister;
